var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { addEventListener } from '@ifeng/ui_base';
import { formatUrl, formatImage } from '@ifeng/public_method';
import { styleName, relText, classNames, formatDate } from '../utils/utils';
import { haveImage } from '../utils/newsStream';
import Basic from '../Basic/Basic';
/* 卡片渲染 */
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card(props) {
        var argu = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            argu[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, [props].concat(argu)) || this;
        _this.state = {
            oldContent: _this.props.content,
            content: _this.props.content,
            isEnd: _this.props.isEnd,
            isLoading: false,
            countMapCache: {}
        };
        if (_this.props.isScrollLoadingData) {
            _this.unlistenerHandleWindowScroll = addEventListener(window, 'scroll', _this.handleWindowScroll);
        }
        return _this;
    }
    // 渲染list
    Card.prototype.cardListView = function (list) {
        var _this = this;
        var cutImage = this.props.cutImage;
        var endIndex = list.length - 1;
        var id = [];
        var width = cutImage && cutImage.cardImage ? cutImage.cardImage.width : 300;
        var height = cutImage && cutImage.cardImage ? cutImage.cardImage.height : 168;
        return list.map(function (item, index) {
            // 获取最后一位的信息，用于加载信息流
            if (index === endIndex)
                _this.lastItem = item;
            // 和推荐位或信息流本身的id去重
            if (_this.props.repeatedID.includes(item.id) || id.includes(item.id))
                return null;
            // 将已渲染id加入到数组
            id.push(item.id);
            var key = item.id + "_" + item.creator + "_" + item.newsTime;
            var url = formatUrl(item.url);
            var isVideo = !!item.videoCount;
            var image;
            if (item.thumbnail) {
                image = item.thumbnail;
            }
            else {
                if (item.thumbnails && typeof item.thumbnails !== 'string' && haveImage(item.thumbnails)) {
                    image = item.thumbnails.image[0].url;
                }
            }
            return (React.createElement("li", { key: key, className: styleName('card-item') },
                React.createElement("a", { className: styleName('card-image-link'), href: url, target: "_blank", ref: relText },
                    React.createElement("div", { className: styleName('card-image-link-mask') }),
                    React.createElement("img", { src: image ? formatImage(image, width, height) : undefined, alt: item.title, width: width, height: height }),
                    React.createElement("i", { className: styleName(isVideo ? 'card-icon-video' : 'card-icon-img') })),
                React.createElement("div", { className: styleName('card-box') },
                    React.createElement("h4", { className: styleName('card-title') },
                        React.createElement("a", { href: url, title: item.title, target: "_blank" }, item.title)),
                    React.createElement("p", { className: styleName('card-summary') }, item.summary),
                    React.createElement("div", { className: classNames(styleName('card-etc'), 'clearfix') },
                        React.createElement("span", { className: styleName('card-etc-time') }, formatDate(item.newsTime)),
                        React.createElement("span", { className: styleName('card-etc-zuozhe') }, item.author)))));
        });
    };
    Card.prototype.render = function () {
        var isDisplayLoadingMore = this.props.isDisplayLoadingMore;
        var _a = this.state, content = _a.content, isLoading = _a.isLoading;
        if (content.length === 0) {
            // 显示加载更多
            return (React.createElement("div", null, isDisplayLoadingMore ? (React.createElement("div", { className: styleName('more-box') },
                React.createElement("span", { className: styleName('is-end') }, "\u6682\u65E0\u6570\u636E"))) : null));
        }
        else {
            return (React.createElement("div", null,
                React.createElement("ul", { ref: this.listRef, className: classNames(styleName('card-news-list'), 'clearfix') }, this.cardListView(content)),
                isDisplayLoadingMore ? (React.createElement("div", { className: styleName('more-box') }, isLoading ? React.createElement("span", { className: styleName('is-end') }, "\u52A0\u8F7D\u4E2D...") : this.moreView())) : null));
        }
    };
    Card.propTypes = {
        content: PropTypes.array,
        columnId: PropTypes.any,
        isEnd: PropTypes.bool,
        repeatedID: PropTypes.array,
        isScrollLoadingData: PropTypes.bool,
        isDisplayLoadingMore: PropTypes.bool,
        moreHref: PropTypes.string,
        cutImage: PropTypes.object,
        ad: PropTypes.arrayOf(PropTypes.object),
        urlId: PropTypes.string,
        dataTypeName: PropTypes.string,
        handleLoadingDataFunc: PropTypes.func // 自定义加载更多函数
    };
    Card.defaultProps = {
        isEnd: false,
        repeatedID: [],
        isScrollLoadingData: false,
        isDisplayLoadingMore: true,
        urlId: '_',
        dataTypeName: 'default'
    };
    return Card;
}(Basic));
export default Card;
